const WEBHOOK_URL =
  "https://script.google.com/a/macros/editinfo.fr/s/AKfycbyCQ2LT5aBuRYOC-iHIGU59rthZxsr7DDEUb_SiGHpwUFYpoqvG-tkQjmvxUW9IrbU/exec";

export interface LeadData {
  prenom: string;
  nom?: string;
  email: string;
  telephone: string;
  situation?: string;
  identiteNumerique: string;
  dejaRealise?: string;
  source?: string;
  code: string;
}

export async function submitLead(data: LeadData): Promise<boolean> {
  const payload = JSON.stringify(data);

  try {
    // Google Apps Script deployed as "Anyone" supports CORS
    // Must use redirect: "follow" because GAS returns a 302
    const response = await fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: payload,
      redirect: "follow",
    });
    console.log("Lead sent, status:", response.status);
    return true;
  } catch (err) {
    console.error("submitLead error:", err);
    return false;
  }
}
